module.exports = __webpack_public_path__ + "img/icon_map_38_on_001.32b81add.png";